import { useMemo } from 'react';
import { useMemberadminTFunction } from './useMemberadminTranslation';
import { OrgRegistrationStatus } from '@dap/memberadmin/types';

export const useOrgStatusLabels = (): Record<OrgRegistrationStatus, string> => {
  const t = useMemberadminTFunction();
  return useMemo(
    () => ({
      [OrgRegistrationStatus.ACTIVE]: t('memberadmin.filter.orgStatus.active'),
      [OrgRegistrationStatus.BANKRUPT]: t('memberadmin.filter.orgStatus.bankrupt'),
      [OrgRegistrationStatus.LIQUIDATING]: t('memberadmin.filter.orgStatus.liquidating'),
      [OrgRegistrationStatus.CEASED]: t('memberadmin.filter.orgStatus.ceased'),
      [OrgRegistrationStatus.NOT_APPLICABLE]: t('memberadmin.filter.orgStatus.notApplicable'),
      [OrgRegistrationStatus.UNKNOWN]: t('memberadmin.filter.orgStatus.unknown'),
    }),
    [t]
  );
};
